module.exports = __webpack_public_path__ + "img/super.a860adfc.png";